import { Mail, MessagesSquare, X } from "lucide-react"

/** Shared, non-blocking message preview for room chat and private conversations. */
export function MessageNotification({ kind, senderName, body, onOpen, onDismiss }: {
  kind: "room" | "direct"
  senderName: string
  body: string
  onOpen: () => void
  onDismiss: () => void
}) {
  const room = kind === "room"
  const Icon = room ? MessagesSquare : Mail
  return (
    <aside
      data-testid={room ? "call-chat-notification" : "meeting-message-notification"}
      aria-label={room ? "New chat message" : "New private message"}
      className="pointer-events-auto flex w-full shrink-0 items-start gap-2 rounded-xl bg-[#202d3d] p-3 text-left text-white shadow-xl ring-1 ring-white/15"
    >
      <button
        type="button"
        aria-label={room ? "Open chat" : `Open message from ${senderName}`}
        onClick={onOpen}
        className="flex min-w-0 flex-1 items-start gap-3 rounded-lg text-left hover:bg-white/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#f6a35c]"
      >
        <Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-[#f6bd8b]" />
        <span className="min-w-0 flex-1" role="status" aria-live="polite" aria-atomic="true">
          <span className="block text-xs text-white/65">{room ? "Room chat" : "Private message"}</span>
          <span className="block truncate text-sm font-semibold leading-5">{senderName}</span>
          <span className="line-clamp-2 break-words text-sm leading-5 text-white/85">{body}</span>
        </span>
      </button>
      <button
        type="button"
        aria-label={room ? "Dismiss chat notification" : "Dismiss message notification"}
        onClick={onDismiss}
        className="-mr-1 -mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white/70 hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#f6a35c]"
      >
        <X aria-hidden="true" className="h-4 w-4" />
      </button>
    </aside>
  )
}
